import React, {useEffect} from 'react';
import {createCategory, deleteCategory, fetchCategories, updateCategory} from "../data/categoryService";
import {Box, Button, IconButton, useTheme} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import columnNames from '../utlis/columnNames';
import validationSchemas from '../utlis/validationSchemas';
import getDataGridStyles from "../utlis/dataGridStyles";
import CommonForm from './Common/CommonForm';
import Header from "./Layout/header/Header";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import DeleteConfirmationDialog from "./Common/DeleteConfirmDialog";
import {tokens} from "../theme";
import useDataManagement from '../utlis/useDataManagement';
import {useTranslation} from 'react-i18next';

const Category = () => {
    const {t} = useTranslation();
    const entityType = 'category';
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dataGridStyle = getDataGridStyles(colors);

    const {
        data,
        selectedData,
        deleteDialogOpen,
        isCardOpen,
        fetchData,
        handleEdit,
        handleCreate,
        handleCloseCard,
        handleDelete,
        handleDeleteDialogClose,
        handleDeleteConfirmed,
        handleSave,
    } = useDataManagement(
        fetchCategories,
        createCategory,
        updateCategory,
        deleteCategory,
        entityType
    );

    useEffect(() => {
        fetchData();
    }, []);
    const columns = [
        ...columnNames.category.map((column) => ({
            ...column,
            headerName: t(column.headerName), // Translate the column header
        })),
        {
            field: 'Actions',
            headerName: t('Actions'),
            flex: 1,
            headerAlign: 'center',
            renderCell: (params) => (
                <div>
                    <IconButton onClick={() => handleEdit(params.row)}>
                        <EditIcon/>
                    </IconButton>
                    <IconButton onClick={() => handleDelete(params.row)}>
                        <DeleteIcon/>
                    </IconButton>
                </div>
            )
        }
    ];

    return (
        <Box m="20px">
            <Header
                title={t("Categories")}
                subtitle={t("List of Categories")}
            />
            <Box display="flex" justifyContent="end" mt="20px">
                <Button onClick={handleCreate} color="secondary" variant="contained">
                    {t("Add Category")}
                </Button>
            </Box>
            <Box
                m="40px 0 0 0"
                height="75vh"
                sx={dataGridStyle}
            >
                <DataGrid
                    rows={data}
                    columns={columns}
                    components={{Toolbar: GridToolbar}}
                />
                <CommonForm
                    open={isCardOpen}
                    onClose={handleCloseCard}
                    title="Category Form"
                    initialValues={{}}
                    validationSchema={validationSchemas.category}
                    onSubmit={handleSave}
                    columnNames={columnNames["category"]}
                    selectedData={selectedData}
                />

                <DeleteConfirmationDialog
                    open={deleteDialogOpen}
                    onClose={handleDeleteDialogClose}
                    onConfirm={handleDeleteConfirmed}
                />
            </Box>
        </Box>
    );
};

export default Category;
